@if (items$ | async; as items) {
<div class="download-cms">
<h3 class="download-cms--title h-500">{{ titleText }}</h3>
@for (item of items; track item?.name) {
<dp-download-item [item]="item"></dp-download-item>
}
@if (isExpandable) {
<div class="download-cms--footer">
  <button [attr.aria-label]="'dpPLP.list.buttonShowMore' | cxTranslate"
    class="btn btn-secondary"
    (click)="loadMore()"
  >
    {{ 'dpPLP.list.buttonShowMore' | cxTranslate }}
  </button>
</div>
}
</div>
}
